import React from 'react'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { FIRST_DATE, FIRST_DAY, SECOND_DATE, SECOND_DAY } from './Constants';
import { API_URL, BACK_URL } from './URLConstants';
import Schedulepage from './Schedulepage';
import { fetchDetails, scrollToTop } from './Api';
import { Link } from 'react-router-dom';


export default function SpeakerPage(props) {

    const [speakers, setspeakers] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const url = `${API_URL}/speakers/${limit}`;
            const data = await fetchDetails(url);
            if (data) {
                setspeakers(data);
            }
            scrollToTop();
        };
        fetchData();
    }, []);


    const styles = {
        backgroundColor: props.color,
    };



    const limit = props.limit;

    return (
        <>
            {/* Limit is {limit}
            {JSON.stringify(speakers)} */}
            <section id="speakers" className="tg-sectionspace tg-haslayout" style={styles}>
                <div className="container">
                    <div className="row">
                        {/* <div
                                className="col-xs-offset-0 col-xs-12 col-sm-offset-0 col-sm-12 col-md-offset-2 col-md-8 col-lg-offset-2 col-lg-8"> */}
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <div className="tg-sectionhead tg-textalignleft">
                                <div className="tg-sectionheading">
                                    {/* <span>Speakers from around the world</span> */}
                                    <h2>Speakers</h2>
                                </div>
                                <div className="tg-description">
                                    {/* <p>Consectetur adipisicing elit sed do eiusmod tempor incididunt labore dolore magna
                                        aliqua enim ad minim veniam quis nostrud exercitation ullamcoaris nisi ut
                                        aliquipa ex ea commodo consequat aute irure.</p> */}
                                </div>
                            </div>
                        </div>
                        <div id="tg-eventspeakerslider" className="tg-eventspeakerslider tg-speakers">

                            {speakers.map(speaker => (

                                <div key={speaker.id} className="item tg-speaker col-md-3" style={limit == 0 ? { height: "450px" } : {}}>
                                    <figure className="tg-speakerimg">
                                        <Link target="_blank" to={`/speakerdetails/${speaker.id}`}>
                                            <img src={`${BACK_URL}/${speaker.image}`} alt="" />
                                        </Link>
                                    </figure>
                                    <div className="tg-contentbox" style={styles}>
                                        <div className="tg-title">
                                            <Link target="_blank" to={`/speakerdetails/${speaker.id}`}>     <h2>{speaker.speakername}</h2></Link>
                                            <Link target="_blank" to={`/speakerdetails/${speaker.id}`}>
                                                <span>{speaker.title}</span>
                                            </Link>
                                        </div>
                                        <div className="tg-description">
                                            <p className="designation">{speaker.designation}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}


                        </div>
                        {/* {limit} */}
                        {limit == 4 ? <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                            <div className="tg-sectionhead tg-textaligncentre">
                                <div className="tg-sectionheadingview">
                                    <Link to='/speaker'><button className="tg-btn">View all speakers</button></Link>
                                </div>
                            </div>
                        </div> : ''}

                    </div>
                </div>
            </section>
        </>
    )
}
